export const cursorForceColResize = "csi-cursor-force-col-resize";
export const cursorForceRowResize = "csi-cursor-force-row-resize";
export const cursorPointer = "csi-cursor-pointer";
export const displayNone = "csi-display-none";
export const height100p = "csi-h100p";
export const imageSmallest = "csi-image-smallest";
export const imageSmall = "csi-image-small";
export const imageMedium = "csi-image-medium";
export const imageLarge = "csi-image-large";
export const imageLargest = "csi-image-largest";
export const flipRTL = "csi-flip-rtl";

const globalCss = {
	[`.${cursorForceColResize}`]: {
		"& *": {
			cursor: "col-resize",
		},
	},
	[`.${cursorForceRowResize}`]: {
		"& *": {
			cursor: "row-resize",
		},
	},
	[`.${cursorPointer}`]: {
		cursor: "pointer",
	},
	[`.${displayNone}`]: {
		display: "none !important",
	},
	[`.${height100p}`]: {
		height: "100%",
	},
	[`.${imageSmallest}`]: {
		/* 64px x 96px */
		fontSize: 10,
		maxHeight: "6.4em",
		maxWidth: "9.6em",
	},
	[`.${imageSmall}`]: {
		/* 128px x 192px */
		fontSize: 10,
		maxHeight: "12.8em",
		maxWidth: "19.2em",
	},
	[`.${imageMedium}`]: {
		/* 256px x 384px */
		fontSize: 10,
		maxHeight: "25.6em",
		maxWidth: "38.4em",
	},
	[`.${imageLarge}`]: {
		/* 384px x 512px */
		fontSize: 10,
		maxHeight: "38.4em",
		maxWidth: "51.2em",
	},
	[`.${imageLargest}`]: {
		/* 512px x 768px */
		fontSize: 10,
		maxHeight: "51.2em",
		maxWidth: "76.8em",
	},
	[`[dir="rtl"] .${flipRTL}`]: {
		transform: "scale(-1, 1)",
	},
};

export default globalCss;
